export const IMAGE_VARIANT = {
  MINI: 'mini',
  MEDIUM: 'medium',
  ORIGINAL: 'original',
}
